import { render, staticRenderFns } from "./KpiTab.vue?vue&type=template&id=e99fcdb0&scoped=true"
import script from "./KpiTab.vue?vue&type=script&lang=ts"
export * from "./KpiTab.vue?vue&type=script&lang=ts"
import style0 from "./KpiTab.vue?vue&type=style&index=0&id=e99fcdb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99fcdb0",
  null
  
)

export default component.exports